import React from 'react';
import { ControlsHubPanelsAssociatedToRisk } from '@interfaces/central-monitoring';
import { NullableStudy } from '@contexts/local-state-context';

export interface IFormData {
    study: NullableStudy | undefined;
    selectionState: SelectionState;
}

export interface IExtendedControlsHubPanelsAssociatedToRisk extends ControlsHubPanelsAssociatedToRisk {
    plotTitle: { active?: boolean | null; name?: string | null };
}

export type SelectionState = {
    recordId?: string;
    selectedItem?: IExtendedControlsHubPanelsAssociatedToRisk;
};

export interface SelectedRowsProps {
    id: number;
}

interface IContext {
    current: IFormData;
    setCurrent: React.Dispatch<React.SetStateAction<IFormData>>;
    setSelectionState: React.Dispatch<React.SetStateAction<SelectionState>>;
}

export const CmControlsContext = React.createContext<IContext>(undefined!);
